export default "__VITE_ASSET__BFdtiaMN__"